export enum AlertType {
  Success = 'success',
  Error = 'error',
}

export interface AlertMessage {
  type: AlertType;
  text: string;
}
